import { DirectivesModule } from './../../directives/directives.module';
import { LoadersModule } from './../loaders/loaders.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DadosProfissionaisComponent } from './dados-profissionais.component';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadersModule,
    DirectivesModule,
    SharedModule,
  ],
  declarations: [
    DadosProfissionaisComponent
  ],
  exports: [
    DadosProfissionaisComponent
  ]
})
export class DadosProfissionaisModule { }
